import {
  Component,
  EventEmitter,
  Input,
  Output,
  OnChanges,
  SimpleChanges
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { GoogleMapsModule } from '@angular/google-maps';

/**
 * MapPickerComponent provides an interactive Google Map for coordinate selection.
 * Users can click on the map or drag the marker to select a location.
 */
@Component({
  selector: 'app-map-picker',
  standalone: true,
  imports: [CommonModule, GoogleMapsModule],
  templateUrl: './map-picker.component.html',
  styleUrls: ['./map-picker.component.scss']
})
export class MapPickerComponent implements OnChanges {
  /** Initial latitude to center the map and place marker */
  @Input() initialLat: number | null = null;

  /** Initial longitude to center the map and place marker */
  @Input() initialLon: number | null = null;

  /** Emitted when user selects a coordinate via click or drag */
  @Output() coordinateSelected = new EventEmitter<{ lat: number; lon: number }>();

  /** Default zoom level for US overview */
  zoom = 6;

  /** Default center: US geographic center */
  center: google.maps.LatLngLiteral = { lat: 39.8283, lng: -98.5795 };

  /** Current marker position (null if no marker placed) */
  markerPosition: google.maps.LatLngLiteral | null = null;

  /** Google Maps configuration options */
  mapOptions: google.maps.MapOptions = {
    mapTypeId: 'satellite',
    zoomControl: true,
    scrollwheel: true,
    disableDoubleClickZoom: false,
    maxZoom: 20,
    minZoom: 2,
    streetViewControl: false
  };

  /** Marker options for draggable red pin */
  markerOptions: google.maps.MarkerOptions = {
    draggable: true
  };

  ngOnChanges(changes: SimpleChanges): void {
    const lat = this.initialLat;
    const lon = this.initialLon;

    if (lat != null && lon != null) {
      this.center = { lat, lng: lon };
      this.markerPosition = { lat, lng: lon };
      this.zoom = 14;
    }
  }

  /**
   * Handles map click events to place/move the marker.
   */
  onMapClick(event: google.maps.MapMouseEvent): void {
    if (event.latLng) {
      const lat = event.latLng.lat();
      const lon = event.latLng.lng();
      this.markerPosition = { lat, lng: lon };
      this.coordinateSelected.emit({ lat, lon });
    }
  }

  /**
   * Handles marker drag end events.
   */
  onMarkerDragEnd(event: google.maps.MapMouseEvent): void {
    if (event.latLng) {
      const lat = event.latLng.lat();
      const lon = event.latLng.lng();
      this.coordinateSelected.emit({ lat, lon });
    }
  }
}
